import type { FaireProductEntity } from "../../entity_types/product";

export const p_s92jammwsr: FaireProductEntity = {
  token: "p_s92jammwsr",
  type: "product",
  name: "MENNO",
  brandToken: "b_7sthum5n64",
  brandName: "KOYD",
  imageUrl:
    "https://cdn.faire.com/fastly/a9d634b3de7020545f4422878af95992a9a11ab9219c5d439eac684dead846eb.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/8e7a8c4842f8a5c8fb23c640313a6fcc0304631a8e86a4b64c641c0ca4dd9d98.jpeg",
    "https://cdn.faire.com/fastly/f52d734e07bb6bdf8a8c6104207a87ad69ac058759f597c006f37d74d60429b7.jpeg",
  ],
  priceDollars: 15,
  description:
    "Menno doesn’t shy away from the spectacular; it’s born in the quiet confidence of realized transformation. Color lives on the walls, in the mirrors, and in the hands of its most skilled artists, transforming all those who walk through the door. Playful and intentional.\n\nIn the moments in between, there is always an ice-cold Diet Coke waiting in the fridge. Popping open the can is like taking a deep breath; nostalgic and familiar. Conversations and laughter cut through the constant hum of the hairdryers, flowing like crisp soda over ice. Unserious moments between people who take their work seriously.\n\nTime moves differently here. You enter as one version of yourself, but leave as another. Warm, bright, soft, refined. Effortlessly transformed, as sweetness lingers in the air and follows you out the door.\n\nMenno lives in your heart long after you leave, and shows you your own true reflection, perhaps for the first time.\n\nCreated for Menno Beauty, located in Sacramento, CA.\n\nTop\n• cola\n• black pepper\n\nHeart\n• cherry\n• vanilla\n\nBase\n• palo santo\n• patchouli\n\n• Olive oil wax\n• 40+ hour burn time\n• Cotton wick\n• Recyclable glass vessel\n• Free of parabens, phthalates, and lead",
  tags: [],
  msrpDollars: 30,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-17T20:26:07.241Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
